import { FC } from "react";

import { OptionalPreferences } from "../views/OptionalPreferences";
import { PopulationServed } from "../views/PopulationServed";
import { ProviderClinicalSpecialties } from "../views/ProviderClinicalSpecialties";
import { ProgramDeliveryPreference } from "../views/ProgramDeliveryPreference";
import { ForWhom } from "../views/ForWhom";
import { ProviderModalities } from "../views/ProviderModalities";
import { ProviderGender } from "../views/ProviderGender";
import { ProviderLanguage } from "../views/ProviderLanguage";
import { ProviderCertifications } from "../views/ProviderCertifications";
import { AdditionalInfo } from "../views/AdditionalInfo";
import { ContactInfo } from "../views/ContactInfo";
import { FormData } from "../App";

export type SelectedOptinalPreferences =
  | "providerModalities"
  | "providerGender"
  | "providerLanguage"
  | "providerCertifications";
export type StepKey =
  | "forWhom"
  | "providerAgeGroups"
  | "providerDeliveryOptions"
  | "providerClinicalSpecialties"
  | "additionalInfo"
  | "providerModalities"
  | "providerGender"
  | "providerLanguage"
  | "providerCertifications"
  | "optionalPreferences";

export interface Step {
  label: string;
  component: FC;
  stepKey: StepKey | null;
  isActive: (selectedOptionalPreferences: SelectedOptinalPreferences[]) => boolean;
  isCompleted: (form: FormData) => boolean;
}

export const steps: Step[] = [
  {
    label: "Seeking a Provider",
    component: ForWhom,
    stepKey: "forWhom",
    isActive: () => true,
    isCompleted: (form) => !!form.forWhom,
  },
  {
    label: "Population Served",
    component: PopulationServed,
    stepKey: "providerAgeGroups",
    isActive: () => true,
    isCompleted: (form) => !!form.providerAgeGroups,
  },
  {
    label: "Program Delivery Preference",
    component: ProgramDeliveryPreference,
    stepKey: "providerDeliveryOptions",
    isActive: () => true,
    isCompleted: (form) =>
      !!(form.providerDeliveryOptions && form.formattedAddress && form.placeId && form.location),
  },
  {
    label: "Primary Concerns",
    component: ProviderClinicalSpecialties,
    stepKey: "providerClinicalSpecialties",
    isActive: () => true,
    isCompleted: (form) => !!form.providerClinicalSpecialties.length,
  },
  {
    label: 'Provider "Must-Haves"',
    component: OptionalPreferences,
    stepKey: "optionalPreferences",
    isActive: () => true,
    isCompleted: () => true,
  },
  {
    label: "Modality",
    component: ProviderModalities,
    stepKey: "providerModalities",
    isActive: (selectedOptionalPreferences) => selectedOptionalPreferences.includes("providerModalities"),
    isCompleted: (form) => !!form.providerModalities,
  },
  {
    label: "Provider Gender",
    component: ProviderGender,
    stepKey: "providerGender",
    isActive: (selectedOptionalPreferences) => selectedOptionalPreferences.includes("providerGender"),
    isCompleted: (form) => !!form.providerGender,
  },
  {
    label: "Provider Language",
    component: ProviderLanguage,
    stepKey: "providerLanguage",
    isActive: (selectedOptionalPreferences) => selectedOptionalPreferences.includes("providerLanguage"),
    isCompleted: (form) => !!form.providerLanguage,
  },
  {
    label: "Program Certification",
    component: ProviderCertifications,
    stepKey: "providerCertifications",
    isActive: (selectedOptionalPreferences) => selectedOptionalPreferences.includes("providerCertifications"),
    isCompleted: (form) => !!form.providerCertifications,
  },
  {
    label: "Additional Info",
    component: AdditionalInfo,
    stepKey: "additionalInfo",
    isActive: () => true,
    isCompleted: () => true,
  },
  {
    label: "Contact Info",
    component: ContactInfo,
    stepKey: null,
    isActive: () => true,
    isCompleted: (form) => !!(form.firstName && form.lastName && form.email),
  },
];
